import { request, requestApiOk } from './client';
import type {
  StoreDetail,
  DeviceRecord,
  StoreInfo,
  UpdateStoreRequest,
  DeviceAliasUpdateRequest,
} from '@/core/types/store';

export function getStores(token: string, signal?: AbortSignal): Promise<StoreDetail[]> {
  return request('GET', '/api/tenant/stores', undefined, token, signal);
}

export function updateStore(
  token: string,
  storeId: string,
  data: UpdateStoreRequest,
): Promise<StoreInfo> {
  return request<StoreInfo>('PATCH', `/api/tenant/stores/${storeId}`, data, token);
}

export function deleteStore(token: string, storeId: string): Promise<void> {
  return requestApiOk('DELETE', `/api/tenant/stores/${storeId}`, undefined, token);
}

export function getStoreDevices(token: string, storeId: string): Promise<DeviceRecord[]> {
  return request('GET', `/api/tenant/stores/${storeId}/devices`, undefined, token);
}

export function updateStoreDeviceAlias(
  token: string,
  storeId: string,
  deviceId: string,
  deviceAlias: string,
): Promise<void> {
  const body: DeviceAliasUpdateRequest = { device_alias: deviceAlias };
  return request(
    'PATCH',
    `/api/tenant/stores/${storeId}/devices/${encodeURIComponent(deviceId)}`,
    body,
    token,
  );
}
